'use client';

import { useParams } from '@/shared/modern-router';

import {
  PageLayoutBreadcrumb,
  PageLayoutHeader,
  PageLayoutSubtitle,
  PageLayoutTitle,
  PageLayoutTop,
} from '@/shared/components/page-layout';
import { Tabs } from '@/shared/components/tabs';
import { useTalentAuth } from '@/shared/contexts/talent-auth';
import PageZero from '@/shared/pid/components/PageZero';

import { useTranslation } from './UtilsPage/hooks';

const PageZeroNotProcess = () => {
  const { t } = useTranslation();
  const { user } = useTalentAuth();
  const pathParams = useParams<{ processId: string; slug: string }>();
  const processId = parseInt(pathParams.processId as string);
  const isBoss = Boolean(
    user.collaborators_count && user.collaborators_count > 0,
  );

  const tabItems = [
    {
      url: `/org/${pathParams.slug}/talent/panel/employee/performance/pid/${processId}/`,
      label: t('MY_PID'),
    },
    {
      url: `/org/${pathParams.slug}/talent/panel/employee/performance/pid/${processId}/my-team/`,
      label: t('MY_TEAM'),
    },
  ];

  const breadcrumbs = [
    {
      text: t('performance'),
      href: `/org/${pathParams.slug}/talent/panel/employee/performance/pid/${processId}/`,
    },
    {
      text: t('PID'),
    },
  ];

  return (
    <>
      <div className="tw-w-full">
        <PageLayoutTop>
          <PageLayoutBreadcrumb items={breadcrumbs} />
          <PageLayoutHeader>
            <PageLayoutTitle title={t('PID_TITLE')} />
            <PageLayoutSubtitle>{t('PID_DESCRIPTION')}</PageLayoutSubtitle>
          </PageLayoutHeader>
        </PageLayoutTop>
        {isBoss && (
          <div className="tw-px-4.8">
            <Tabs tabItems={tabItems} />
          </div>
        )}
      </div>
      <div className="tw-w-full tw-px-4.8 tw-bg-neutral-light-200 tw-h-[69vh] tw-py-2.4">
        <div className="tw-w-full tw-flex tw-h-[60vh] tw-items-center tw-justify-center tw-bg-neutral-light-100 tw-rounded-1">
          <div>
            <PageZero
              img="https://crehana-vercel-images-prd.imgix.net/public/PID/f361b977-4326-4991-876a-eb27b73b3a86-pagezeropid.png?auto=format&fit=clip"
              title={t('TITLE_PAGE_ZERO_NOT_PROCES')}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PageZeroNotProcess;
